import React from 'react';
import {CircularProgress, LinearProgress, Stack, Typography} from "@mui/material"
import QualityCheckJson from "../../api/json/QualityCheckJson"

interface Props {
    qualityCheckJson: QualityCheckJson
    totalValidationExamples: number
    endpointStarting?: boolean
}

function QualityCheckProgressBar({qualityCheckJson, totalValidationExamples, endpointStarting}: Props) {
    const completed = qualityCheckJson.stats.completedTestRuns
    const total = Math.max(totalValidationExamples, 1)
    const percent = Math.min(100, Math.round((completed / total) * 100))
    const running = completed > 0

    // The label changes only at real phase boundaries (minutes apart), never for transient
    // sub-second states — text that gets replaced before it can be read is worse than no text.
    // Finer detail lives in the caption, which stays empty until the endpoint status is known.
    const label = running ? "Running test cases" : "Starting quality check"
    const caption = running ? null
        : endpointStarting ? "Starting the model endpoint — dedicated hardware usually takes a few minutes."
            : endpointStarting === false ? "Endpoint is online — preparing test cases."
                : null

    return (
        <Stack spacing={1} sx={{bgcolor: "background.paper", border: 1, borderColor: "divider", borderRadius: 2, p: 2}}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
                <Stack direction="row" spacing={1} alignItems="center">
                    {!running && <CircularProgress size={14} thickness={5}/>}
                    <Typography variant="body2" sx={{fontWeight: 600}}>{label}</Typography>
                </Stack>
                {running &&
                    <Typography variant="body2" color="text.secondary">
                        {completed.toLocaleString()} of {total.toLocaleString()} · {percent}%
                    </Typography>
                }
            </Stack>
            {running &&
                <LinearProgress variant="determinate" value={percent} sx={{borderRadius: 1}}/>
            }
            {caption && <Typography variant="caption" color="text.secondary">{caption}</Typography>}
        </Stack>
    );
}

export default QualityCheckProgressBar;
